module.exports = __webpack_public_path__ + "img/Weapon_220.f366abc3.png";